import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeleteDocument {
  onSuccess: () => void
  onError: (error: any) => void
}

export const useDeleteDocument = ({ onSuccess, onError }: UseDeleteDocument) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteDocument'],
    mutationFn: async (documentId?: string) => {
      return privateAxios.delete(`/general_documents/${documentId}`)
    },
    onSuccess,
    onError,
  })
}
